/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Send_TitleInputs */

const en_mcp_cap_send_title = /** @type {(inputs: Mcp_Cap_Send_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send whatever you're reading`)
};

const es_mcp_cap_send_title = /** @type {(inputs: Mcp_Cap_Send_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envía lo que estés leyendo`)
};

/**
* | output |
* | --- |
* | "Send whatever you're reading" |
*
* @param {Mcp_Cap_Send_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_send_title = /** @type {((inputs?: Mcp_Cap_Send_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Send_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_send_title(inputs)
	return en_mcp_cap_send_title(inputs)
});